import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_MARITALTAX,
  DELETE_MARITALTAX,
  UPDATE_MARITALTAX,
  ADD_NEW_MARITALTAX,
} from "./actionType";

import {
  getMaritalTaxSuccess,
  getMaritalTaxFail,
  deleteMaritalTaxSuccess,
  deleteMaritalTaxFail,
  updateMaritalTaxSuccess,
  updateMaritalTaxFail,
  addMaritalTaxSuccess,
  addMaritalTaxFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveMaritalTaxApi,
  getMaritalTaxApi,
  updateMaritalTaxApi,
  deleteMaritalTaxApi,
  addNewMaritalTaxApi
} from "../../helpers/backend_helper";

function* getMaritalTax({ payload: maritalTax }) {
  try {
    const response = yield call(getMaritalTaxApi, maritalTax);
    yield put(getMaritalTaxSuccess(GET_MARITALTAX, response.data));
  } catch (error) {
    yield put(getMaritalTaxFail(GET_MARITALTAX, error));
  }
}

function* onUpdateMaritalTax({ payload: maritalTax }) {
  try {
    if (maritalTax.setApprove) {
      const response = yield call(approveMaritalTaxApi, maritalTax);
      yield put(updateMaritalTaxSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateMaritalTaxApi, maritalTax);
      yield put(updateMaritalTaxSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateMaritalTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteMaritalTax({ payload: maritalTax }) {
  try {
    const response = yield call(deleteMaritalTaxApi, maritalTax);
    yield put(deleteMaritalTaxSuccess({ maritalTax, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteMaritalTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewMaritalTax({ payload: maritalTax }) {
  try {
    const response = yield call(addNewMaritalTaxApi, maritalTax);
    yield put(addMaritalTaxSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addMaritalTaxFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetMaritalTax() {
  yield takeEvery(GET_MARITALTAX, getMaritalTax);
}

export function* watchUpdateMaritalTax() {
  yield takeEvery(UPDATE_MARITALTAX, onUpdateMaritalTax);
}

export function* watchDeleteMaritalTax() {
  yield takeEvery(DELETE_MARITALTAX, onDeleteMaritalTax);
}

export function* watchAddNewMaritalTax() {
  yield takeEvery(ADD_NEW_MARITALTAX, onAddNewMaritalTax);
}

function* maritalTaxSaga() {
  yield all([
    fork(watchGetMaritalTax),
    fork(watchDeleteMaritalTax),
    fork(watchUpdateMaritalTax),
    fork(watchAddNewMaritalTax)
  ]);
}

export default maritalTaxSaga;
